import type { DataCity } from 'common/dataService/types/countriesTypes';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import FetchingStatus from 'constants/statuses/FetchingStatus';

export type DataCitiesState = {
  fetching: FetchingStatus | null;
  value: DataCity[] | [];
  countryCode: string | null;
};

const initialState: DataCitiesState = {
  fetching: null,
  value: [],
  countryCode: null,
};

function setFetchingFunction(state: DataCitiesState, action: PayloadAction<DataCitiesState['fetching']>) {
  return {
    ...state,
    fetching: action.payload,
  };
}

function setCountryCodeFunction(state: DataCitiesState, action: PayloadAction<DataCitiesState['countryCode']>) {
  return {
    ...state,
    countryCode: action.payload,
  };
}

function setDataCitiesFunction(state: DataCitiesState, action: PayloadAction<DataCitiesState['value']>) {
  return {
    ...state,
    value: action.payload,
  };
}

const slice = createSlice({
  name: 'dataService.dataCities',
  initialState,
  reducers: {
    setFetching: setFetchingFunction,
    setCountryCode: setCountryCodeFunction,
    setDataCities: setDataCitiesFunction,
  },
});

export const { setFetching, setCountryCode, setDataCities } = slice.actions;
export default slice.reducer;
